import React, { useCallback, useEffect } from 'react';

import { useWorkflowContext } from 'app/editor/workflow/context';
import ChatMessage from 'app/editor/workflow/items/ChatMessage';
import AIAgent from 'app/editor/workflow/items/AIAgent';
import AIWorkflow from 'app/editor/workflow/items/AIWorkflow';
import CallSearch from 'app/editor/workflow/items/CallSearch';
import { IItemFlowProps } from './index';
import ItemWrapper from './ItemWrapper';

const ComponentMap = new Map<string, React.ComponentType<IItemFlowProps>>([
    ['chat_message', ChatMessage],
    ['ai_agent', AIAgent],
    ['ai_workflow', AIWorkflow],
    ['call_search', CallSearch],
]);

export default function WorkflowItem({ saveItemSettings }: { saveItemSettings: (settings: any) => void }) {
    const { workflowItems, workflowId, selectedItem, itemSettingsMap, setItemSettingsMap } = useWorkflowContext();

    const item = selectedItem ? workflowItems[selectedItem] : null;
    if (!item || !selectedItem) {
        return null;
    }

    const Component = ComponentMap.get(item.role);
    if (Component) {
        return (
            <ItemWrapper key={'ItemWrapper_' + selectedItem}>
                <Component
                    key={selectedItem}
                    workflowItemSettings={itemSettingsMap[selectedItem] ?? '{}'}
                    saveItemSettings={saveItemSettings}
                />
            </ItemWrapper>
        );
    }

    return <div>Workflow Item {JSON.stringify(item)}</div>;
}
